module.exports = __webpack_public_path__ + "static/media/biometria-facial.cce596e4.jpg";